export default {
	18_24: '18 to 24 years-old',
	25_30: '25 to 30 years-old',
	31_40: '31 to 40 years-old',
	41_50: '41 to 50 years-old',
	51_60: '51 to 60 years-old',
	'60_plus': 'More than 60 years-old',
	you_dont_have_this_badge_yet: "You don't have this badge yet",
	you_got_this_badge_on: 'You got this badge on',
	accept_terms: 'Accept terms',
	accept_terms_and_conditions: 'I do accept the terms and conditions',
	access_the_website_from_the: 'Access your Profile section in',
	activity_feed: 'Activity Feed',
	age: 'Age',
	approved: 'Approved',
	are_you_a_painter: 'Are you a painter?',
	avatar_photo_optional: 'Avatar/Photo (optional)',
	awaiting_approval: 'Awaiting approval',
	birthday: 'Birthday',
	birthday_date: 'Birthday',
	birthday_date_hint: 'To change it, you need to edit all the data (year/month/day).',
	born_in: 'Birthday in',
	branch: 'Store',
	brand: 'Brand',
	cellphone: 'Cellphone',
	change_avatar: 'Change Avatar',
	change_phone: 'Change phone',
	verification_code_sent: 'Verification code sent',
	error_sending_verification_code: 'Error sending verification code',
	change_password: 'Change password',
	children: 'Children',
	city: 'City',
	commercial_phone: 'Commercial phone',
	company_agency: 'Company/Store',
	complement: 'Line 2',
	communication_phone: 'Communication phone',
	confirm_password: 'Confirm password',
	contact_information: 'Contact information',
	country: 'Country',
	current_password: 'Current password',
	delivered: 'Delivered',
	document_not_unique: 'Document already used',
	each_level_has_exclusive_benefits_check_out_the:
		'Each level has its exclusive benefits. Check it out!',
	email_confirm: 'Email confirm',
	email_dont_match: 'Emails do not match',
	email_receipt_change_successfully_changed: 'Email receipt change successfully changed',
	error_changing_password_check_your_current_password_or_try_again_later:
		'Error changing password. Check your current password or try again later',
	event_checkin: 'Event check-in',
	event_qrcode_checkin: 'Event',
	female: 'Female',
	file_upload: 'Photo upload',
	file_upload_reproval: 'Rejected Photo Upload',
	from: 'from',
	gender: 'Genre',
	general: 'General',
	gmin_number: 'GMIN number',
	go_to_reward_store: 'Go to Rewards Store',
	handicap_description: 'Description of the special need',
	i_agree_to_receive_interesting_emails_and_recommendations:
		'I agree to receive interesting emails and recommendations',
	i_wish_to_receive_emails_from_intel_rewards_you_program:
		'I wish to receive e-mails from Intel Rewards You program',
	inbox: 'Messages',
	information: 'Information',
	intel_retail_edge_program: 'Intel® Retail Edge Program',
	invalid_phone: 'Invalid phone number',
	is_handicapped: 'Do you have a disability?',
	justification: 'Justification',
	kdv_code: 'CADV code',
	last_name: 'Last Name',
	level_up: 'Level up',
	male: 'Male',
	marital_status: 'Marital Status',
	message: 'Message',
	mobile_phone: 'Cell phone',
	more_than: 'more than',
	my_data: 'My Data',
	my_points: 'My Points',
	name: 'Name',
	neighborhood: 'District/Suburb',
	new_password: 'New password',
	nickname: 'Nickname',
	no_address_found: 'No address found',
	no_certificates_available: 'No certificates found',
	no_events_in_your_activity_feed_come_back_later:
		'No events in your activity feed. Come back later.',
	number: 'Number ',
	number_of_children: 'Number of children',
	open_points_history: 'Open points record',
	open_points_statement: 'Open point statement',
	order: 'Order',
	order_history: 'Order Record',
	orders: 'Redemptions',
	others: 'Others',
	painter: 'Painter',
	password_changed_successfully: 'Password changed successfully',
	past_months: 'Past months ',
	personal_information: 'Personal Information',
	phone: 'Telephone',
	phone_number: 'Phone',
	phone_verified: 'Phone verified',
	phone_social_information: 'Confirmation required',
	phone_not_verified: 'Phone not verified. Check the number validation message in your WhatsApp.',
	phone_to_receive_notifications_promotions_and_account_settings: 'Phone number to receive notifications, invitations and account recovery.',
	points_earned_during_the_campaign: 'Points earned in the campaign',
	profession: 'Profession',
	professional_information: 'Professional Information',
	profile_edited_successfully: 'Profile edited successfully',
	profile_successfully_changed: 'Profile successfully changed',
	program_rule: 'Program Rules',
	redeem: 'Redeem',
	resend_verification: 'Resend verification',
	register: 'Record',
	reject_terms: 'Reject terms',
	reproved: 'Rejected',
	residential_phone: 'Home Phone',
	retailer: 'Retailer',
	sale: 'Sale',
	sale_reproval: 'Rejected Sales',
	search_address: 'Search address ',
	search_by_street_name_and_number: 'Search by street, name and number',
	see_all_badges: 'See all badges',
	see_all_certificates: 'View all certificates',
	see_the_full_ranking: 'See the full ranking',
	select_profile: 'Select profile',
	shipped: 'Shipped',
	show_ranking: 'Show ranking',
	state: 'State',
	statement: 'Statement',
	store_nickname: 'Store nickname (optional)',
	there_are_no_messages_available_at_the_moment: 'No messages available',
	these_data_cannot_be_changed: 'These data cannot be changed.',
	this_campaign: 'This campaing',
	to: 'until',
	to_change_the_information_bellow: 'if you need to update your personal data.',
	total_credits_available_to_spend: 'Total credits available to spend',
	training_special: 'Mandatory training bonus',
	type_photo_upload: 'type photo upload',
	undefined: 'I prefer not to reveal',
	user_avatar_changed: 'Avatar updated',
	user_level_up: 'User level up',
	user_registered: 'User registered',
	we_couldnt_find_any_messages_with_the_current_search: 'No messages found in this search',
	wait: 'Wait',
	whats_your_profession: "What's your profession?",
	whatsapp: 'Whatsapp',
	you_dont_have_any_points_yet: "You don't have any points yet",
	you_dont_have_certificates_in_this_category: "You dont't have certificates in this category yet",
	you_have: 'you have',
	your_account_has_been_created_and_is_awaiting_for_aproval_you_will_receive_an_email:
		'Your account has been created and is awaiting for approval. You will receive an email confirming.',
	your_account_has_been_created_verify_your_email_for_instructions:
		"Your account has been created. Verify your email for instructions. Don't forget to check your spam folder.",
	your_password_must_contain_at_least_characters:
		'Your password must contain at least 6 characters',
	your_password_must_contain_at_least_characters_uppercase_letters_lowercase_letters_numbers:
		'Your password must contain at least 6 characters, uppercase letters, lowercase letters, numbers',
	your_password_must_contain_at_least_characters_uppercase_letters_lowercase_letters_numbers_and_symbols:
		'Your password must contain at least 6 characters, uppercase letters, lowercase letters, numbers and symbols {symbols}',
	your_ranking_position_will_be_available_after_you_complete_at_least_one_course:
		'Your ranking position will be available after you complete at least one course.',
	find_your_network: 'Find your network',
	select_your_branch: 'Select your branch',
	email_unsubscribe_label: 'I would like to receive information via email'
}
